import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasClasificarmovimientosMasivoListaComponent (FinanzasClasificarMovimientos) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.$onChanges = $onChanges;
  $ctrl.eliminarEmpleado = eliminarEmpleado;
  $ctrl.doMatch = doMatch;
  $ctrl.actualizar = actualizar;

  function $onInit () {
    calcularTotal();
  }

  function eliminarEmpleado (item) {
    $ctrl.data.empleados.splice($ctrl.data.empleados.indexOf(item), 1);
    calcularTotal();
    buscarMovimiento();
  }

  function calcularTotal () {
    if ($ctrl.data.empleados) {
      var total = 0;
      $ctrl.data.empleados.forEach(function (item) {
        total += item.Importe;
      });
      // total = Math.round( total * 10 ) / 10;
      $ctrl.total = angular.copy(total.toFixed(2));
    }
  }

  function $onChanges (changes) {
    if (changes.data) {
      $ctrl.data = changes.data.currentValue;
      $ctrl.data.empleados.map(function (item) {
        item.Importe = item.Neto;
        return item;
      });
      $ctrl.data.movimiento.monto = Math.round($ctrl.data.movimiento.monto * 10) / 10;
      calcularTotal();
    }
  }

  function actualizar (item, data) {
    $ctrl.data.empleados.splice($ctrl.data.empleados.indexOf(item), 1, data);
    calcularTotal();
    buscarMovimiento();
  }

  function buscarMovimiento () {
    FinanzasClasificarMovimientos.buscarMovimiento($ctrl.total, $ctrl.cuenta, $ctrl.data.movimiento.fecha).then(function (response) {
      if (response.data)
        $ctrl.encontroMovimiento({$event: {data: response.data}});
    });
  }

  function doMatch (data) {
    $ctrl.data.empleados.map(function (item) {
      item.coincide = !!data.find((elemento) => item.Num_Cuenta_2 == elemento.cuenta && item.Neto == elemento.deposito);
      data.forEach((elemento) => {
        if (item.Num_Cuenta_2 == elemento.cuenta && item.Neto != elemento.deposito){
          item.Importe = elemento.deposito;
        }
      })
    })

    calcularTotal()
    buscarMovimiento()
  }
}

module.component('finanzasClasificarmovimientosMasivoLista', {
  controller: FinanzasClasificarmovimientosMasivoListaComponent,
  template,
  bindings: {
    clasificarMovimiento: '&',
    data: '<',
    clasificado: '<',
    cuenta: '<',
    encontroMovimiento: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/masivo/lista/component.js